const BASE_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:9000";

export const API_ENDPOINTS = {
  // --------------------- Admin Login ---------------------------
  LOGIN: `${BASE_URL}/admin/auth/login`,

  // --------------------- Dashboard ---------------------------
  DASHBOARD_API: `${BASE_URL}/admin/dashboard`,

  // --------------------- Sales Page ----------------------------
  CREATE_SALES: `${BASE_URL}/sales`,
  GET_SALES: `${BASE_URL}/sales`,
  GET_SALES_SUMMARY: `${BASE_URL}/sales/summary`,
  GET_SALES_BY_ID: `${BASE_URL}/sales/by-id`,
  UPDATE_SALES: `${BASE_URL}/sales`,
  UPDATE_SALE_COMMISSION: `${BASE_URL}/sales`,
  DELETE_SALES_PERMANENTLY: `${BASE_URL}/sales/delete-permanently`,
  DELETE_SALES: `${BASE_URL}/sales`,

  // --------------------- Refunds Page ----------------------------
  GET_REFUNDS: `${BASE_URL}/refunds`,
  GET_REFUNDS_BY_ID: `${BASE_URL}/refunds`,

  // --------------------- Expense Type Page ----------------------------
  CREATE_EXPENSE_TYPE: `${BASE_URL}/expense-type`,
  GET_EXPENSE_TYPE: `${BASE_URL}/expense-type`,
  GET_EXPENSE_TYPE_BY_ID: `${BASE_URL}/expense-type/by-id`,
  UPDATE_EXPENSE_TYPE: `${BASE_URL}/expense-type`,
  DELETE_EXPENSE_TYPE: `${BASE_URL}/expense-type`,
  DELETE_EXPENSE_TYPE_PERMANENTLY: `${BASE_URL}/expense-type/delete-permanently`,

  // --------------------- Expense Page ----------------------------
  CREATE_EXPENSE: `${BASE_URL}/expenses`,
  GET_EXPENSE: `${BASE_URL}/expenses`,
  GET_EXPENSE_SUMMARY: `${BASE_URL}/expenses/summary`,
  UPDATE_EXPENSE: `${BASE_URL}/expenses`,
  DELETE_EXPENSE: `${BASE_URL}/expenses`,
  MATERIALIZE_RECURRING_EXPENSE: `${BASE_URL}/expenses/recurring/materialize`,

  // --------------------- Finance Dashboard ---------------------------
  GET_KPI_REPORT: `${BASE_URL}/reports/kpis`,
  GET_SALES_COUNT: `${BASE_URL}/reports/sales-count`,
  GET_PROFIT_LOSS_REPORT: `${BASE_URL}/reports/profit-loss`,
  GET_PRODUCT_BREAKDOWN: `${BASE_URL}/reports/product-breakdown`,
  GET_UPGRADE_METRICS: `${BASE_URL}/reports/upgrade-metrics`,
  GET_SUBSCRIPTION_METRICS: `${BASE_URL}/subscriptions/metrics`,
  GET_COMMISSION_RULES: `${BASE_URL}/commission-rules`,
  GET_ACE_PROGRESS: `${BASE_URL}/commission/ace-progress`,
  GET_COMMISSION_DASHBOARD_SUMMARY: `${BASE_URL}/commission/dashboard-summary`,
  GET_STRIPE_RECONCILIATION: `${BASE_URL}/stripe/reconciliation-report`,
  GET_STRIPE_DEBUG: `${BASE_URL}/stripe/debug`,
  GET_CONFIG: `${BASE_URL}/config`,
  UPDATE_CONFIG: `${BASE_URL}/config`,
  UPDATE_FC_MOTIVATE_PERCENTAGE: `${BASE_URL}/config/fc-motivate-percentage`,

  // --------------------- Settings ----------------------------
  GET_SETTINGS: `${BASE_URL}/settings`,
  UPDATE_SETTINGS: `${BASE_URL}/settings`,

  // --------------------- Stripe Products ----------------------------
  GET_STRIPE_PRODUCTS_CONFIG: `${BASE_URL}/stripe-products/config`,
  SYNC_STRIPE_PRODUCTS: `${BASE_URL}/stripe-products/sync`,
  UPDATE_STRIPE_PRODUCT_TRACKING: `${BASE_URL}/stripe-products/tracking`,

  // --------------------- Analytics Truth ---------------------------
  ANALYTICS_TRUTH_OVERVIEW: `${BASE_URL}/analytics-truth/overview`,
  ANALYTICS_TRUTH_FINANCE_KPIS: `${BASE_URL}/analytics-truth/finance-kpis`,
  ANALYTICS_TRUTH_SALES_COUNT: `${BASE_URL}/analytics-truth/sales-count`,
  ANALYTICS_TRUTH_REVENUE: `${BASE_URL}/analytics-truth/revenue`,
  ANALYTICS_TRUTH_MRR: `${BASE_URL}/analytics-truth/mrr`,
  ANALYTICS_TRUTH_FUNNEL_METRICS: `${BASE_URL}/analytics-truth/funnel-metrics`,
  ANALYTICS_TRUTH_CONSISTENCY_REPORT: `${BASE_URL}/analytics-truth/consistency-report`,

  // --------------------- Marketing Analytics ---------------------------
  MARKETING_OVERVIEW: `${BASE_URL}/marketing-analytics/overview`,
  MARKETING_UTM_BREAKDOWN: `${BASE_URL}/marketing-analytics/utm-breakdown`,
  MARKETING_REVENUE_ATTRIBUTION: `${BASE_URL}/marketing-analytics/revenue-attribution`,
  MARKETING_UNATTRIBUTED_REVENUE: `${BASE_URL}/marketing-analytics/unattributed-revenue`,
  MARKETING_LEAD_TRENDS: `${BASE_URL}/marketing-analytics/lead-trends`,
  MARKETING_ATTRIBUTION_BREAKDOWN: `${BASE_URL}/marketing-analytics/attribution-breakdown`,
  MARKETING_ATTRIBUTION_DRILLDOWN: `${BASE_URL}/marketing-analytics/attribution-drilldown`,

  // --------------------- Attribution Mappings ---------------------------
  ATTRIBUTION_MAPPINGS: `${BASE_URL}/attribution-mappings`,

  // --------------------- Funnel Analytics ---------------------------
  FUNNEL_METRICS: `${BASE_URL}/funnel/metrics`,
  FUNNEL_PIPELINE_DISTRIBUTION: `${BASE_URL}/funnel/pipeline-distribution`,
  FUNNEL_REVENUE_BY_STAGE: `${BASE_URL}/funnel/revenue-by-stage`,
  FUNNEL_DESTINATION_BREAKDOWN: `${BASE_URL}/funnel/destination-breakdown`,

  // --------------------- Vidalytics -----------------------------------
  VIDALYTICS_EVENTS: `${BASE_URL}/vidalytics/events`,
  VIDALYTICS_ANALYTICS: `${BASE_URL}/vidalytics/analytics`,

  // --------------------- GA4 Analytics ---------------------------
  GA4_STATUS: `${BASE_URL}/ga4/status`,
  GA4_SYNC: `${BASE_URL}/ga4/sync`,
  GA4_METRICS: `${BASE_URL}/ga4/metrics`,
  GA4_TRAFFIC_SOURCES: `${BASE_URL}/ga4/traffic-sources`,
  GA4_LANDING_PAGES: `${BASE_URL}/ga4/landing-pages`,
  GA4_EVENTS: `${BASE_URL}/ga4/events`,
  GA4_EVENTS_RECENT: `${BASE_URL}/ga4/events/recent`,

  // --------------------- GHL Integration ---------------------------
  GHL_STATUS: `${BASE_URL}/ghl/status`,
  GHL_PIPELINE_METRICS: `${BASE_URL}/ghl/pipeline-metrics`,
  GHL_OPPORTUNITIES: `${BASE_URL}/ghl/opportunities`,
  GHL_EMAIL_METRICS: `${BASE_URL}/ghl/email-metrics`,
  GHL_EMAIL_STATS: `${BASE_URL}/ghl/email/stats`,
  GHL_SYNC_EMAIL: `${BASE_URL}/ghl/email/sync`,
  GHL_SYNC_EMAIL_VERIFY_OTP: `${BASE_URL}/ghl/email/sync/verify-otp`,
  GHL_SYNC_EMAIL_METRICS: `${BASE_URL}/ghl/sync/email-metrics`,
  GHL_SYNC_PIPELINE_METRICS: `${BASE_URL}/ghl/sync/pipeline-metrics`,
  GHL_SYNC_CONTACTS: `${BASE_URL}/ghl/sync/contacts`,
  GHL_SYNC_OPPORTUNITIES: `${BASE_URL}/ghl/sync/opportunities`,
  GHL_SYNC_APPOINTMENTS: `${BASE_URL}/ghl/sync/appointments`,
  GHL_SYNC_FUNNEL: `${BASE_URL}/ghl/sync/funnel`,
  GHL_SYNC_FUNNEL_VERIFY_OTP: `${BASE_URL}/ghl/sync/funnel/verify-otp`,
  GHL_DEBUG: `${BASE_URL}/ghl/debug`,

  // --------------------- UTM Links ---------------------------
  UTM: `${BASE_URL}/utm`,
  UTM_OPTIONS: `${BASE_URL}/utm/options`,
  UTM_GENERATE: `${BASE_URL}/utm/generate`,
  UTM_LIST: `${BASE_URL}/utm/list`,
  UTM_EXPORT: `${BASE_URL}/utm/export`,
};
